;(function() {
  'use strict'

  Controller.$inject = ["mediaView", "$timeout"];
  angular.module('app.survey').component('surveyQuestion', {
    controller: Controller,
    templateUrl: 'survey-question.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller(mediaView, $timeout) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy
    ctrl.expandImage = mediaView.showImage

    function onInit() {
      // populate choice pipes before question is skipped
      ctrl.question.populateChoicePipes()

      if (ctrl.question.type === ctrl.question.Types.HIDDEN_VARIABLES) {
        console.log('Skipped Hidden Variables Q' + ctrl.question.number)
        // HIDDEN VARIABLES question is not shown to respondent so we skip it
        skipQuestion()
        return
      }
      if (ctrl.question.autoPunched()) {
        console.log('Auto Punched Q' + ctrl.question.number)
        // if question is auto punched, skip the question
        skipQuestion()
        return
      }

      console.log('Viewing Q' + ctrl.question.number)
      ctrl.title = ctrl.survey.injectValues(
        ctrl.question.titlePipes,
        ctrl.question.loopKey
      )

      if (ctrl.question.description) {
        ctrl.description = ctrl.survey.injectValues(
          ctrl.question.descriptionPipes,
          ctrl.question.loopKey
        )
      } else if (ctrl.question.type === ctrl.question.Types.CONSTANT_SUM) {
        ctrl.description = 'Please enter a numeric value for each option.'
      }

      ctrl.ready = true
      ctrl.question.timer.start()
    }

    function skipQuestion() {
      // skip question by going to the next or previous view
      // use timeout to simulate a digest to fix issue where ctrl.question
      // is undefined on onDestroy hook after skipped/autopunched
      $timeout(function() {
        if (ctrl.survey.actionClicked === 'back') {
          ctrl.survey.prev()
        } else {
          ctrl.survey.next()
        }
      })
    }

    function onDestroy() {
      ctrl.question.timer.stop()
    }
  }
})()
